import * as tslib_1 from "tslib";
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToolBarToolComponent } from './toolbar-tool.component';
/**
 * @hidden
 */
var ToolBarButtonListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ToolBarButtonListComponent, _super);
    function ToolBarButtonListComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemClick = new EventEmitter();
        return _this;
    }
    ToolBarButtonListComponent.prototype.getText = function (dataItem) {
        if (dataItem) {
            return this.textField ? dataItem[this.textField] : dataItem.text || dataItem;
        }
        return undefined;
    };
    ToolBarButtonListComponent.prototype.onClick = function (item) {
        if (item.click) {
            item.click();
        }
        this.itemClick.emit(this.data.indexOf(item));
    };
    ToolBarButtonListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'kendo-toolbar-buttonlist',
                    template: "\n        <button tabindex=\"-1\" kendoButton\n            class=\"k-overflow-button\"\n            *ngFor=\"let item of data\"\n            [disabled]=\"item.disabled\"\n            [icon]=\"item.icon\"\n            [iconClass]=\"item.iconClass\"\n            [imageUrl]=\"item.imageUrl\"\n            (click)=\"onClick(item)\">\n            {{ getText(item) }}\n        </button>\n    "
                },] },
    ];
    /** @nocollapse */
    ToolBarButtonListComponent.ctorParameters = function () { return []; };
    ToolBarButtonListComponent.propDecorators = {
        'data': [{ type: Input },],
        'textField': [{ type: Input },],
        'itemClick': [{ type: Output },],
    };
    return ToolBarButtonListComponent;
}(ToolBarToolComponent));
export { ToolBarButtonListComponent };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-toolbar/dist/es/tools/toolbar-buttonlist.component.js
// module id = ../../../../@progress/kendo-angular-toolbar/dist/es/tools/toolbar-buttonlist.component.js
// module chunks = vendor